import { FC, useState, useEffect } from 'react'
import { ViewportType } from './types'
import BarChart from './BarChart'
import BarChartMobile from './BarChartMobile'

const PricingBarChart: FC = () => {
  // State
  const [barChart, setBarChart] = useState<ViewportType>(ViewportType.DESKTOP)

  useEffect(() => {
    updateSize()
    window.addEventListener('resize', updateSize)

    return () => window.removeEventListener('resize', updateSize)
  }, [])

  /**
   * Shows correct bar chart
   */
  const updateSize = () => {
    if (window.innerWidth < 900) {
      setBarChart(ViewportType.MOBILE)
    } else {
      setBarChart(ViewportType.DESKTOP)
    }
  }

  return barChart === ViewportType.DESKTOP ? <BarChart /> : <BarChartMobile />
}

export default PricingBarChart
